import { ReadOnlyStepProps } from "../useStepEditor";
import { Stack, Title, useTheme } from "@introist/react-foundation/v2";
import { Block } from "../../../../components/atoms";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";

export const AiActionStepViewer = ({ step }: ReadOnlyStepProps) => {
  const { theme } = useTheme();

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Instructions" defaultOpen={false}>
          <Stack vertical>
            <Title>These were the instructions for what the AI should do.</Title>
            <Title color={theme.palette.foreground.default}>
              {(step.resolvedData as any).instructions}
            </Title>
          </Stack>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Result">
          <Stack vertical>
            <Title>This is what the AI produced.</Title>
            <Title color={theme.palette.foreground.default}>
              {(step.executionData as any).result}
            </Title>
          </Stack>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Report" defaultOpen={false}>
          <Stack vertical>
            <Title>This is AIs report on what it did.</Title>
            <Title color={theme.palette.foreground.default}>
              {(step.executionData as any).report}
            </Title>
          </Stack>
        </StepEditorAccordion>
      </Block>
    </>
  );
};
